export default "__VITE_ASSET__0d5e2e8a__"